import React, { Component } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { SubmissionError } from 'redux-form';

import Spinner from 'components/Spinner';
import BaseModal from '../BaseModal';
import PlanForm from 'components/PlanForm';
import { DATE_TIME_FORMAT } from '../../../constants';

import styles from './styles.module.scss';

class ImmediateRenewalModal extends Component {
  constructor(props) {
    super(props);
    this.checkboxRef = React.createRef();
    this.state = {
      loading: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.fetchPlans();
    }
  }

  fetchPlans() {
    const { fetchAllPlans, subId, isOpen } = this.props;
    if (isOpen) {
      const params = { subscription_id: subId };

      this.setState({ loading: true });
      fetchAllPlans(params)
        .catch((e) => toast.error('Failed to load subscription plans'))
        .finally(() => this.setState({ loading: false }));
    }
  }

  handleSubmit = async (values) => {
    const { subId, immediateRenewal, findSub } = this.props;
    let executionDate;
    let newValues = { ...values };

    if (newValues.execution_dt) {
      executionDate = moment.utc(newValues.execution_dt, DATE_TIME_FORMAT);
      newValues.execution_dt = executionDate.toISOString();
    }

    if (executionDate && executionDate < Date.now()) {
      throw new SubmissionError({
        execution_dt: 'Datetime should be in the future',
      });
    }

    this.setState({ loading: true });
    return immediateRenewal(subId, newValues)
      .then(() => findSub(subId))
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { subId, sub, closeModal, isOpen, plans } = this.props;
    const { loading } = this.state;
    const { plan } = sub;
    let initialValues = { plan_id: plan && plan.id };
    if (sub.upcoming_plan) {
      initialValues = {
        plan_id: sub.upcoming_plan.id,
      };
    } else if (sub.plan) {
      initialValues = {
        plan_id: sub.plan.id,
      };
    }

    return (
      <BaseModal
        isOpen={isOpen}
        title="Scheduled Renewal"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <PlanForm
          {...this.props}
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          {...{ subId }}
          plans={plans}
          isModal
          showExecutionDate
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default ImmediateRenewalModal;
